import Apis from '@/Apis/_'
import EventBus from '@/plugins/EventBus'
import Vue from 'vue'
import { NotificacaoEmailVariavel, UseNotificacaoEmailVariaveisState } from './types'
import { RequestOptionsProps } from '../types'

const useNotificacaoEmailVariaveis = (() => {
  const state = Vue.observable<UseNotificacaoEmailVariaveisState>({
    variaveisPorTipo: {},
  })

  function variaveisDoTipo(tipo: string): NotificacaoEmailVariavel[] {
    return state.variaveisPorTipo[tipo] || []
  }

  async function loadVariaveis(tipo: string, {
    forceRefresh = false,
    showToastError = true,
  }: RequestOptionsProps = {}) {
    if (!tipo) {
      return { success: true, data: [] }
    }

    if (state.variaveisPorTipo[tipo] && !forceRefresh) {
      return { success: true, data: state.variaveisPorTipo[tipo] }
    }

    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getVariaveisNotificacao(tipo)

    if (response.success) {
      Vue.set(state.variaveisPorTipo, tipo, response.data || [])
    } else if (showToastError) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Ocorreu um erro ao buscar as variáveis disponíveis.',
        icon: 'warning',
        color: '#C62828',
      })
    }

    return response
  }

  return {
    variaveisDoTipo,
    loadVariaveis,
  }
})()

export default useNotificacaoEmailVariaveis
